import Slider from '@mui/material/Slider'
import styles from '../onboarding.module.scss'
import { useDispatch, useSelector } from 'react-redux'
import {
	registerUsingActivationCode,
	updateProfile,
} from '../../../features/authSlice'
import ButtonCustom from '../../atoms/button/ButtonCustom'

const MIN = 5
const MAX = 10000

export const VenueMaxCapacity = ({ userDetails, setUserDetails, role, setStep }) => {
	const dispatch = useDispatch()

	const email = useSelector((state) => state.auth.user.email)

	const handleChange = (e, newValue) => {
		setUserDetails({ ...userDetails, maxCapacity: newValue })
	}

	const handleChangeMaxCapacity = (e) => {
		const value = parseInt(e.target.value)
		if (value >= MIN && value <= MAX) {
			setUserDetails({ ...userDetails, maxCapacity: value })
		}
	}

	const handleSubmit = async () => {
		if (userDetails.hasActivationCode) {
			try {
				// If Wedding Join Code exists, add them to wedding
				const res = await dispatch(
					registerUsingActivationCode({
						verificationCode: userDetails.activationCode.trim(),
						email,
                        role
					})
				).unwrap()

				if (!res || !res.success) return
			} catch (err) {
				console.log(err)
				return
			}
		}
		dispatch(updateProfile({ ...userDetails, role: 'vendor' }))
	}

	return (
		<div className={`${styles.form}`}>
			<h1>Max Capacity</h1>
			<p>
				Enter your count below. <br />
				Don't worry, it doesn't have to be the <i>exact</i> number
			</p>

			<div className={styles.priceRange}>
				<input
					style={{ maxWidth: '100px' }}
					onChange={handleChangeMaxCapacity}
					value={userDetails.maxCapacity}
				/>
			</div>
			<Slider
				value={userDetails.maxCapacity}
				onChange={handleChange}
				valueLabelDisplay="auto"
				max={MAX}
				min={MIN}
				sx={{
					color: '#7ca6bd',
					'& .MuiSlider-track': { backgroundColor: '#7ca6bd' },
					'& .MuiSlider-thumb': {
						border: '0.1px solid white',
						width: '12px',
						height: '12px',
					},
					'& .MuiSlider-rail': {
						backgroundColor: '#FFFFFF',
						opacity: 1,
					},
				}}
			/>
			<div className={styles.skipBtn}>
				<button
					data-cy="backbutton"
					onClick={() => {
						setStep((step) => step - 1)
					}}
					className="backButton"
				>
					Back
				</button>
				<ButtonCustom onClick={handleSubmit} data-cy="nextButton">
					Finish
				</ButtonCustom>
			</div>
		</div>
	)
}
